import { capitaliseFirstWord } from '@monash/portal-frontend-common';
import { format } from 'date-fns';

export const getTagText = ({ status, publishDate }) => {
  const capitalisedStatus = capitaliseFirstWord(status);

  if (publishDate) {
    return `${capitalisedStatus}: ${format(publishDate, 'dd/MM/yyyy h:mmaaa')}`;
  }

  return capitalisedStatus;
};
